/* ---- Carousel Reviews: Ver más / Modal JS ---- */
(function () {
  var CHAR_THRESHOLD = 120; // caracteres mínimos para mostrar "Ver más"

  /* ---- Crear el overlay del modal (una sola vez) ---- */
  function createModal() {
    if (document.getElementById('carousel-review-modal-overlay')) return;
    var overlay = document.createElement('div');
    overlay.id = 'carousel-review-modal-overlay';
    overlay.className = 'carousel-review-modal-overlay';
    overlay.innerHTML = [
      '<div class="carousel-review-modal-content">',
        '<button class="carousel-review-modal-close" aria-label="Cerrar">&times;</button>',
        '<div class="carousel-modal-body-wrapper"></div>',
      '</div>'
    ].join('');
    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.classList.contains('carousel-review-modal-close')) {
        closeModal();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  function openModal(cardClone) {
    var overlay = document.getElementById('carousel-review-modal-overlay');
    var wrapper = overlay.querySelector('.carousel-modal-body-wrapper');
    wrapper.innerHTML = '';
    wrapper.appendChild(cardClone);
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    var overlay = document.getElementById('carousel-review-modal-overlay');
    if (overlay) {
      overlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  /* ---- Procesar cada tarjeta ---- */
  function processCard(card) {
    if (card.dataset.crProcessed) return;
    card.dataset.crProcessed = '1';

    /* Selector real de la app: div.testText y el <p> dentro */
    var textWrap = card.querySelector('.testText');
    var textEl   = textWrap
      ? (textWrap.querySelector('p') || textWrap)
      : null;

    if (!textEl) return;

    var text = (textEl.innerText || textEl.textContent || '').trim();
    if (text.length < CHAR_THRESHOLD) return; /* texto corto, no necesita "Ver más" */

    /* Marcar el contenedor con nuestras clases CSS */
    if (textWrap && !textWrap.classList.contains('carousel-review-text-wrap')) {
      textWrap.classList.add('carousel-review-text-wrap');
    }
    textEl.classList.add('carousel-review-body', 'clamped');

    /* Botón "Ver más" */
    var btn = document.createElement('button');
    btn.className = 'carousel-ver-mas show';
    btn.textContent = 'Ver más';
    btn.setAttribute('aria-label', 'Ver reseña completa');

    var container = textWrap || textEl.parentNode;
    container.appendChild(btn);

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var clone = card.cloneNode(true);
      /* Limpiar clases de clamp y botón en el clon */
      clone.querySelectorAll('.carousel-review-body').forEach(function (el) {
        el.classList.remove('clamped');
      });
      clone.querySelectorAll('.carousel-ver-mas').forEach(function (el) {
        el.remove();
      });
      openModal(clone);
    });
  }

  function scanCards() {
    document.querySelectorAll('li.itemsC').forEach(processCard);
  }

  function init() {
    createModal();
    scanCards();

    /* Observar cambios dinámicos (la app carga las tarjetas via JS) */
    var observer = new MutationObserver(scanCards);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
